import React, { useState, useRef, useEffect } from "react";
import styles from "./ActionReplays.module.scss";
import TinySlider from "tiny-slider-react";
import SliderControls from "./SliderButton";
import sliderStyles from "./TinySlider.module.scss";
//import { animOnSwipe } from '../scripts/animation';
import { isMobile, isIOS } from "react-device-detect";
import ActionReplayPlaceholder from "../components/ActionReplayPlaceholder";
import { AzureMP } from "react-azure-mp";
import { Context } from "../Store";
import ReactPlayer from "react-player/lazy";
import { eventNames } from "../utils/eventData";
import { capitalize } from "../utils/helpers";
import ShareArrow from "./ShareArrow";
import CopiedContext from "../CopiedContext";
import IsCopiedMessage from "./IsCopiedMessage";

// Inner slider component to enable clean remounting when filter changes
const ActionReplaySlider = ({
  videos,
  players,
  handleHover,
  openLightbox,
  sliderClickHandler,
  sliderHoverHandler,
  state,
}) => {
  const sliderRef = useRef();

  const settings = {
    lazyload: true,
    touch: true,
    nav: false,
    controlsContainer: "." + styles.sliderContainer + " .sliderControls",
    mouseDrag: true,
    loop: videos.length > 1,
    items: 1,
    responsive: {
      640: {
        items: videos.length < 2 ? videos.length : 2,
        edgePadding: 30,
      },
    },
  };

  return (
    <div
      className={styles.sliderContainer}
      onClick={sliderClickHandler}
      onMouseLeave={isMobile ? () => false : sliderHoverHandler}
      onMouseOver={isMobile ? () => false : sliderHoverHandler}
    >
      <SliderControls slider={sliderRef}></SliderControls>

      <TinySlider settings={settings} ref={sliderRef}>
        {videos.map((video, index) => (
          <div key={index} data-index={index} style={{ position: "relative" }} className={styles.actionReplayItem}>
            {!video.thumbnail_url && <ActionReplayPlaceholder video={{ video }} players={{ players }} />}
            {video.thumbnail_url && <img src={video.thumbnail_url} alt="" />}
            <div className={styles.actionReplayText}>
              <span className={styles.actionReplayTitle}>
                {capitalize(players.find((p) => p.id === Number(video.players))?.name)}: {eventNames[video.type]}
              </span>
            </div>
            <ShareArrow
              title={`${capitalize(players.find((p) => p.id === Number(video.players))?.name)}: ${eventNames[video.type]}`}
              url={video.video_url}
              text={`Check out this ${eventNames[video.type]} Action Replay from our Electric Shuffle visit.`}
              downloadUrl={video.video_url}
              isVideo={true}
              customBottom="0px"
              sectionName="Action Replay"
              mediaShare={{
                mediaType: "VIDEO",
                mediaURI: video.asset_uri,
                videoURL: video.video_url,
                sectionName: "Action Replay",
                thumbnail: video.thumbnail_url,
                videoType: video.type,
              }}
              cityurl={state.cityurl}
              venue={state.venue}
              azureurl={state.azureurl}
              videourl={state.videourl}
              guid={state.guid}
              country={state.country}
            />
          </div>
        ))}
      </TinySlider>
    </div>
  );
};

const ActionReplays = (props) => {
  const state = React.useContext(Context);
  const [showCopied, setShowCopied] = useState(false);
  const [selectedPlayerId, setSelectedPlayerId] = useState("all");

  const copiedContextValue = {
    showCopied,
    setShowCopied,
  };

  let players = Array.isArray(state.players) ? state.players : [];
  const videos = Array.isArray(state.actionReplays) ? state.actionReplays : [];

  // Get unique players who have action replays

  const playersWithReplays = players
    .filter((player) => videos.some((video) => Number(video.players) === Number(player.id)))
    .sort((a, b) => (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" }));

  // Filter videos based on selected player
  const filteredVideos =
    selectedPlayerId === "all" ? videos : videos.filter((video) => Number(video.players) === Number(selectedPlayerId));

  const getEventType = (eventID) => {
    switch (eventID) {
      case 5:
        return "Last puck overtake";
      case 50:
        return "Hanger";
      case 51:
        return "Score5";
      case 52:
        return "Score4";
      case 100:
        return "ShortCircuit";
      case 150:
        return "LateGameSteal20";
      case 151:
        return "LateGameSteal30";
      case 152:
        return "LateGameSteal40";
      case 153:
        return "LateGameSteal50";
      case 154:
        return "LateGameSteal60";
      case 155:
        return "LateGameSteal70";
      case 200:
        return "TotalEclipse";
      case 201:
        return "PartialEclipse25mm";
      case 202:
        return "PartialEclipse50mm";
      default:
        return "Undefined";
    }
  };

  let actionReplaysVideos = filteredVideos.map((video) => {
    if (video.video_url.includes(".mp4")) {
      return (
        <div className={styles.actionReplayItem}>
          <ReactPlayer
            className="react-player"
            url={video.video_url}
            muted
            controls
            playing
            width="100%"
            height="100%"
          />
        </div>
      );
    } else {
      return (
        <div className={styles.actionReplayItem}>
          <AzureMP
            options={{ controls: true, autoplay: true, muted: true }}
            src={[{ src: video.video_url, type: "application/vnd.ms-sstr+xml" }]}
          />
        </div>
      );
    }
  });
  let actionReplaysMedia = filteredVideos.map((video) => {
    return {
      mediaType: "VIDEO",
      mediaURI: video.asset_uri,
      mediaProvider: video.video_provider,
      videoURL: video.video_url,
      sectionName: "Action Replay",
      eventType: getEventType(video.type),
      eventName: eventNames[video.type],
    };
  });

  // useEffect(() => {
  //   animOnSwipe(sliderRef.current.slider);
  // }, [sliderRef]);

  const handleHover = (index, target, type) => {
    let perviewDetails = {
      section: "ActionReplay",
      index: index,
      ...actionReplaysMedia[index],
      target: target,
      groupLength: actionReplaysMedia.length,
      sources: actionReplaysVideos,
      mediashare: actionReplaysMedia,
    };
    props.handleHover(perviewDetails, type);
  };

  const openLightbox = (index) => {
    let lightboxDetails = {
      section: "ActionReplay",
      index: index,
      sources: actionReplaysVideos,
      mediashare: actionReplaysMedia,
    };

    props.openLightbox(lightboxDetails);
  };

  const sliderClickHandler = (e) => {
    // Don't trigger lightbox if clicking on ShareArrow or title
    if (
      e.target.closest('[class*="shareContainer"]') ||
      e.target.closest('[class*="actionReplayText"]') ||
      e.target.closest("button") ||
      e.target.closest("svg")
    ) {
      return;
    }

    let slide = e.target.closest(`.${styles.actionReplayItem}`);
    if (slide) {
      openLightbox(+slide.getAttribute("data-index"));
    }
  };
  let currentHover = null;
  const sliderHoverHandler = (e) => {
    // Don't trigger hover if over ShareArrow or title
    if (
      e.target.closest('[class*="shareContainer"]') ||
      e.target.closest('[class*="actionReplayText"]') ||
      e.target.closest("button") ||
      e.target.closest("svg")
    ) {
      return;
    }

    let slide = e.target.closest(`.${styles.actionReplayItem}`);
    if (slide && currentHover == null) {
      currentHover = slide.getAttribute("data-index");
      handleHover(+currentHover, slide, "mouseenter");
    } else if (!slide || e.type == "mouseleave") {
      handleHover(+currentHover, slide, "mouseleave");
      currentHover = null;
    }
  };

  return (
    <CopiedContext.Provider value={copiedContextValue}>
      <div className="section">
        <h2>GAME HIGHLIGHTS</h2>
        <p>Big plays. Big energy.</p>

        {playersWithReplays.length > 1 && (
          <div className={styles.filterRow}>
            <label className={styles.filterLabel} htmlFor="playerFilter">
              Filter by player:
            </label>
            <select
              id="playerFilter"
              className={styles.filterSelect}
              value={selectedPlayerId}
              onChange={(e) => setSelectedPlayerId(e.target.value)}
            >
              <option value="all">All Players</option>
              {playersWithReplays.map((player) => (
                <option key={player.id} value={player.id}>
                  {capitalize(player.name)}
                </option>
              ))}
            </select>
          </div>
        )}

        <ActionReplaySlider
          key={selectedPlayerId}
          videos={filteredVideos}
          players={players}
          handleHover={handleHover}
          openLightbox={openLightbox}
          sliderClickHandler={sliderClickHandler}
          sliderHoverHandler={sliderHoverHandler}
          state={state}
        />
        <IsCopiedMessage />
      </div>
    </CopiedContext.Provider>
  );
};

export default ActionReplays;
